import { Heading } from '@lmig/lmds-react-typography';
import { Button } from '@lmig/lmds-react-button';
import { GridCol, GridRow } from '@lmig/lmds-react-grid';
import { IconCopy, IconAddItem } from '@lmig/lmds-react-icons';
import { Modal, ModalBody, ModalFooter } from '@lmig/lmds-react-modal';
import { useState } from 'react';
import { Badge } from '@lmig/lmds-react-badge';
import { CircularProgressSpinner } from '@lmig/sales-ui-circular-progress-spinner';
import globalConfig from './../../Data/globalConfig.json';
import { isBLProd } from 'Foundation/Configurations/GlobalConfiguration';
import { Notification } from '@lmig/lmds-react-notification';

interface INewUser {
  agencyCode: string | undefined;
}

export function CreatePortalUser({ agencyCode }: INewUser) {
  const [isOpen, setIsOpen] = useState(false);
  const [accessCode, setAccessCode] = useState<string>();
  const [copied, setCopied] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const GetAccessCode = async () => {
    setCopied(false);
    setAccessCode(undefined);
    setIsOpen(true);
    setIsLoading(true);
    const response = await fetch(`/api/sitecore/AgencyAPIAsync/GetAccessCode?agencyCode=${agencyCode}`);
    if (!response.ok) {
      let error = await response.text();
      setIsLoading(false);
      console.error(`ERROR - ${JSON.stringify(error)}\n`);
    } else {
      setIsLoading(false);
      let data = await response.json();
      if (data && data.agencyAccess && data.agencyAccess?.length) setAccessCode(data.agencyAccess[0].accessCode);
    }
  };

  const SetUpNewUser = () => {
    setIsOpen(false);
    let url: string = isBLProd() ? globalConfig.BL.userRegistration.prod : globalConfig.BL.userRegistration.nonProd;
    window.open(url, '_blank');
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="small" className="create-new-user-modal">
        <ModalBody>
          <Heading type="h3-light">Copy access code below to add new user:</Heading>
          {accessCode && !isLoading ? (
            <div
              className="access-code-link"
              onClick={() => {
                navigator.clipboard.writeText(accessCode);
                setCopied(true);
              }}
            >
              <Heading type="h3-bold">{accessCode}</Heading>
              <IconCopy></IconCopy>
              {copied && <Badge highlightType="positive">Copied</Badge>}
            </div>
          ) : isLoading ? (
            <CircularProgressSpinner
              className="portal-users-loading-spinner"
              size="24"
              aria-label="Getting access code"
            />
          ) : (
            <Notification alert="Our system is unable to complete the request." highlightType="negative">
              If you have your access code from your welcome email, click Next to proceed.
            </Notification>
          )}
        </ModalBody>
        <ModalFooter>
          <GridRow gutterSize="fixed-16" gutters>
            <GridCol base={12} md={6}>
              <Button dynamicWidth onClick={() => setIsOpen(false)}>
                Cancel
              </Button>
            </GridCol>
            <GridCol base={12} md={6}>
              <Button dynamicWidth variant="primary" onClick={() => SetUpNewUser()}>
                Next
              </Button>
            </GridCol>
          </GridRow>
        </ModalFooter>
      </Modal>
      <div className="create-portal-user" onClick={() => GetAccessCode()} tabIndex={0}>
        <IconAddItem size="16" /> Create new user
      </div>
    </>
  );
}
